var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.043 6.498C22.5 8.28 22.5 12 22.5 12C22.5 12 22.5 15.72 22.043 17.502C21.789 18.487 21.046 19.262 20.105 19.524C18.396 20 12.5 20 12.5 20C12.5 20 6.607 20 4.895 19.524C3.95 19.258 3.208 18.484 2.957 17.502C2.5 15.72 2.5 12 2.5 12C2.5 12 2.5 8.28 2.957 6.498C3.211 5.513 3.954 4.738 4.895 4.476C6.607 4 12.5 4 12.5 4C12.5 4 18.396 4 20.105 4.476C21.05 4.742 21.792 5.516 22.043 6.498ZM10.5 15.5L16.5 12L10.5 8.5V15.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYt);
export default __webpack_public_path__ + "static/media/yt.b15ca70bf443fe456765e85bd2c3a608.svg";
export { ForwardRef as ReactComponent };